import { Formik, Form } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Grid, Header, Segment } from 'semantic-ui-react';
import { RiderFormValues } from '../../../../app/models/permit';
import {v4 as uuid} from 'uuid';
import { useStore } from '../../../../app/stores/store';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import MyZipCodeInput from '../../../../app/common/form/MyZipCodeInput';
import MyPhoneInput from '../../../../app/common/form/MyPhoneInput';
import { RiderFormValidationSchema } from '../../../../app/common/form/FormikFormValidations';
import { getButtonSize } from '../../../../app/common/util/util';

interface Props {
    setAddRiderMode: (status: boolean) => void
}

export default observer(function PermitDetailedRiderAddForm({ 
    setAddRiderMode
 }: Props) {
    const {permitStore} = useStore();
    const {addTempRider} = permitStore;
    
    function handleFinalFormSubmit(formValues: RiderFormValues) {
        let newRider =  {
            id: uuid(),
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            address: formValues.address,
            address2: formValues.address2,
            city: formValues.city,
            zipcode: formValues.zipcode,
            phone: formValues.phone,

            employerName: formValues.employerName,
            employerCity: formValues.employerCity,
            employerZipcode: formValues.employerZipcode
        };
        addTempRider(newRider);
        setAddRiderMode(false);
    }

    return (
        <Formik
            initialValues={new RiderFormValues()}
            onSubmit={(values) => handleFinalFormSubmit(values)}
            validationSchema={RiderFormValidationSchema}
        >
            {({handleSubmit, isSubmitting, errors, values}) => (
                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                    <Grid>
                        <Grid.Column computer={8} tablet={8} mobile={16}>
                            <Segment clearing>
                                <Header content='Home Address' sub color='teal' />
                                <label>First Name</label>
                                <MyTextInput name='firstName' placeholder='First Name' tabIndex={1} />


                                <label>Last Name</label>
                                <MyTextInput name='lastName' placeholder='Last Name' tabIndex={2} />

                                <label>Address</label>
                                <MyTextInput name='address' placeholder='Address' tabIndex={3} />

                                <label>Address 2</label>
                                <MyTextInput name='address2' placeholder='Address 2' tabIndex={4} />

                                <label>City</label>
                                <MyTextInput name='city' placeholder='City' tabIndex={5} />

                                <label>Zip Code</label>
                                <MyZipCodeInput name='zipcode' placeholder='Zip Code' tabIndex={6} />

                                <label>Phone</label>
                                <MyPhoneInput name='phone' placeholder='Phone' tabIndex={7} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column computer={8} tablet={8} mobile={16}>
                            <Segment>
                                <Header content='Work Destination' sub color='teal' />
                                <label>Company/Place</label>
                                <MyTextInput name='employerName' placeholder='Employer Name' tabIndex={8} />

                                <label>City</label>
                                <MyTextInput name='employerCity' placeholder='Employer City' tabIndex={9} />

                                <label>Zip Code</label>
                                <MyZipCodeInput name='employerZipcode' placeholder='Employer Zip Code' tabIndex={10} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={16}>
                            <Button 
                                loading={isSubmitting}
                                floated='right'
                                positive
                                type='submit'
                                content={'Add values'}
                                size={getButtonSize()}
                            /> 
                        </Grid.Column>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
})